module.exports = __webpack_public_path__ + "static/media/mode-535.aa9a3451.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-535.svg
// module id = 1053
// module chunks = 2